export default __webpack_public_path__ + "static/media/avatar.6ea8c10a.jpg";